<div class="page-box">
  <div class="page-container">
    <div class="header" [class.header--hide]="isHeader()">
      <div class="container-box">
        @if (isShellReady()) {
          <app-header-menu></app-header-menu>
        }
      </div>
    </div>
    @if (!isLoading()) {
      <router-outlet></router-outlet>
    }
    @if (showLoader()) {
      <div class="page-loader page-loader--all-space page-loader--with-white-bg">
        <app-spinner></app-spinner>
      </div>
    }
  </div>
  @if (isShellReady()) {
    <app-footer [class.visually-hidden--box]="isHiddenFooter()"></app-footer>
  }
</div>
<app-alert class="alert-toaster"></app-alert>
